import { useAuth } from "@/contexts/AuthContext";
import { useTranslation } from "react-i18next";
import { Building2 } from "lucide-react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";

/**
 * Indicador de planta (todos los usuarios) y selector de planta activa (Super Admin).
 * Se monta en el header del sidebar (Layout).
 */
export default function PlantSwitcher() {
  const { t } = useTranslation();
  const { user, plants, activePlantId, switchPlant } = useAuth();
  if (!user || !user.id) return null;

  const isSuper = user.is_super;
  const currentName = user.active_plant_name || user.plant_name || t("plant.plant");

  if (!isSuper) {
    return (
      <div
        data-testid="plant-indicator"
        className="mx-3 mt-3 flex items-center gap-2 px-3 py-2 rounded-sm bg-zinc-900 border border-zinc-800"
      >
        <Building2 size={16} className="text-[var(--brand,#E31E24)] shrink-0" />
        <div className="min-w-0">
          <p className="text-[9px] uppercase tracking-widest text-slate-500 leading-none mb-0.5">{t("plant.plant")}</p>
          <p className="text-xs font-bold text-white truncate leading-none">{currentName}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="mx-3 mt-3">
      <p className="text-[9px] uppercase tracking-widest text-slate-500 mb-1 px-1">{t("plant.active")}</p>
      <Select value={activePlantId || ""} onValueChange={switchPlant}>
        <SelectTrigger
          data-testid="plant-switcher"
          className="bg-zinc-900 border-zinc-800 text-white h-10 text-xs hover:bg-zinc-800"
        >
          <div className="flex items-center gap-2 min-w-0">
            <Building2 size={16} className="text-[var(--brand,#E31E24)] shrink-0" />
            <SelectValue placeholder={t("plant.select")} />
          </div>
        </SelectTrigger>
        <SelectContent>
          {(plants || []).map((p) => (
            <SelectItem key={p.id} value={p.id} data-testid={`plant-option-${p.id}`}>
              {p.name}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
